export default __webpack_public_path__ + "static/r2-8aea433310f0efd32c381abe9bd8b313.png";